<template lang="pug">
  div
    //- Temporary variable allows us to click outside
    //- of the drawer to dismiss it.
    v-navigation-drawer.green.darken-2(
      v-model="drawerVisible"
      app
      dark
      temporary
    )
      //- We need to clamp height here because the SVG of a bug
      //- in Vuetify where using the contain attribute doesn't
      //- propagate the new width/height correctly.
      v-layout#avatar-box.fill-height.clamp-height(
        tag="v-list"
        column
      )
        //- Avatar and User Name line
        v-list-tile(avatar)
          v-list-tile-avatar
            v-img(
              :src="require('../../assets/avatar/default-avatar.svg')"
              contain
              height="60px"
            )
          v-list-tile-title.title {{ fullName }}
        #guest-spacer(v-if="!authenticated")
          v-list-tile(@click="pageTransfer('login')")
            v-list-tile-action
              v-icon fas fa-sign-in-alt
            v-list-tile-content Driver Log In
          v-list-tile(@click="")
            v-list-tile-action
              v-icon fas fa-user-plus
            v-list-tile-content Driver Sign Up
        #auth-spacer(v-else)
          v-list-tile(@click="logout()")
            v-list-tile-action
              v-icon fas fa-sign-out-alt
            v-list-tile-content Log Out
      //- TODO 3/5/2019: Convert to v-for
      v-list
        v-list-tile(@click="pageTransfer('')")
          v-list-tile-action
            v-icon fas fa-home
          v-list-tile-content
            v-list-tile-title Home
        v-list-tile(@click="pageTransfer('postnewjob')")
          v-list-tile-action
            v-icon fas fa-plus-square
          v-list-tile-content
            v-list-tile-title New Job
        v-list-tile(@click="pageTransfer('jobs')")
          v-list-tile-action
            v-icon fas fa-briefcase
          v-list-tile-content
            v-list-tile-title Find Jobs
        v-list-tile(@click="pageTransfer('pages/faq')")
          v-list-tile-action
            v-icon fas fa-question-circle
          v-list-tile-content
            v-list-tile-title FAQ
        v-list-tile(@click="pageTransfer('pages/contact')")
          v-list-tile-action
            v-icon fas fa-phone-square
          v-list-tile-content
            v-list-tile-title Contact Us
    v-toolbar(
      dark
      color="primary"
    )
      //- Hamburger Icon
      v-toolbar-side-icon(@click="drawerVisible = !drawerVisible")
      //- Toolbar Logo, always shown
      router-link(to="/")
        img(
          :src="require('../../assets/logo.svg')"
          :height="$vuetify.breakpoint.mdAndUp ? '64px' : '48px'"
        )
      //- Generates whitespace between logo and links
      v-spacer
      v-toolbar-items.hidden-sm-and-down
        v-btn(
          flat
          @click="pageTransfer('postnewjob')"
        ) New Job
        v-btn(
          flat
          @click="pageTransfer('jobs')"
        ) Find Jobs
        v-btn(
          flat
          @click="pageTransfer('pages/faq')"
        ) FAQ
        v-btn(
          flat
          @click="pageTransfer('pages/contact')"
        ) Contact Us
</template>

<script>
import {
  mapActions,
  mapGetters,
} from 'vuex';

export default {
  data: () => ({
    drawerVisible: false,
  }),
  computed: {
    ...mapGetters([
      'authenticated',
      'fullName',
    ]),
  },
  methods: {
    ...mapActions([
      'logout',
    ]),
    pageTransfer(to) {
      this.$router.push(`/${to}`);
    },
  },
};
</script>

<style lang="stylus" scoped>
#avatar-box
  background url('/images/avatar-backdrop.jpg')

#auth-spacer
  margin-top 63px

#guest-spacer
  margin-top 15px

.clamp-height
  max-height 175px !important
</style>
